const sideBar = {
  'xsmall': '100vw',
  'small': '100vw',
  'medium': '80vw',
  'large': '70vw',
  'xlarge': '60vw',
};

export default sideBar;
